<template lang="pug">
.row.d-flex.flex-md-row-reverse.align-items-center.i_mt_10.i_mt_sm_4
  .col-md-7.col-lg-7.i_pr_0
    .info.i_pl_8.i_pl_md_3.i_pt_2.i_pl_sm_0
      .title.d-flex.justify-content-between.aiign-items-cemter
        h5 {{ location.LocationName }}
        svg-icon.d-md-none(
          iconClass="chevron-circle-down-solid",
          className="chevron-circle-down-solid",
          :class="{ expand: isExpand }"
        )
        .map_title_btn(@click="isExpand = !isExpand")
        .map_title_cover.d-none.d-md-block
      ul
        li.i_mt_2
          svg-icon(iconClass="ic_place", className="icon")
          span.i_ml_1 {{ location.LocationAddr }}
        li.i_mt_2
          svg-icon(iconClass="ic_phone", className="icon")
          span.i_ml_1 {{ location.LocationTel }}
        li.i_mt_2
          svg-icon(iconClass="ic_fax", className="icon")
          span.i_ml_1 {{ location.LocationFax }}
      h5.i_mt_12.i_mt_md_4 {{ location.LocationENName }}
      p {{ location.LocationENAddr }}
  .col-md-5.d-flex.justify-content-center.justify-content-lg-end.col-lg-5.i_plr_0.i_pr_6.i_pr_md_2.i_mt_sm_4
    img.map(
      style="cursor: pointer",
      :class="{ expand: isExpand }",
      :src="location.LocationImage",
      @click="mapClick(location)"
    )
</template>

<script>
export default {
  name: "Tab",
  props: {
    location: Object,
    selected: Boolean,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    mapClick(location) {
      window.open(
        "https://www.google.com/maps/search/" + location.LocationAddr
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/location/map";
</style>
